<div class="d-flex" [ngClass]="customClass" style="white-space: pre">
  <span [ngStyle]="{ order: +(position === 'right') }">{{ currency }}</span>
  <span *ngIf="currencyCode !== 'BTC'">{{ value | numberFormat : true }}</span>
  <span *ngIf="currencyCode === 'BTC'">{{ value | bitcoinFormat }}</span>
</div>
